import { useNavigate } from '@tanstack/react-router';

import type { InsuranceType } from '../../../context/InsuranceTypeContext';
import { useInsuranceType } from '../../../hooks/useInsuranceType';
import { useTranslation } from '../../../hooks/useTranslation';
import { toast } from '../../../lib/toast';

export type ServiceItem = {
  id: string;
  icon: 'car' | 'heart' | 'home' | 'shield';
  title: string;
  description: string;
  link: string;
  disabled: boolean;
};

export const useServices = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setSelectedType } = useInsuranceType();

  const data = {
    label: t('home.services.label'),
    title: t('home.services.title'),
    services: [
      {
        id: 'auto',
        icon: 'car' as const,
        title: t('home.services.auto.title'),
        description: t('home.services.auto.description'),
        link: '/form',
        disabled: false,
      },
      {
        id: 'life',
        icon: 'heart' as const,
        title: t('home.services.life.title'),
        description: t('home.services.life.description'),
        link: '/form',
        disabled: true,
      },
      {
        id: 'home',
        icon: 'home' as const,
        title: t('home.services.home.title'),
        description: t('home.services.home.description'),
        link: '/form',
        disabled: false,
      },
      {
        id: 'disability',
        icon: 'shield' as const,
        title: t('home.services.disability.title'),
        description: t('home.services.disability.description'),
        link: '/form',
        disabled: true,
      },
    ],
  };

  const handleServiceClick = (service: ServiceItem) => {
    if (service.disabled) {
      toast.info('toast.comingSoon', {
        messageParams: { service: service.title },
      });
      return;
    }
    setSelectedType(service.id as InsuranceType);
    navigate({ to: '/consent' });
  };

  return {
    data,
    handleServiceClick,
  };
};

export type ServicesProps = ReturnType<typeof useServices>;
